const feature = {
  state: {
    userHandle: ''
  },
  getters: {
    userHandle: state => state.userHandle
  },
  mutations: {
    SET_USER_HANDLE: (state, userHandle) => {
      state.userHandle = userHandle
    },
  },
  actions: {
    SetUserHandle({ commit }, userHandle) {
      commit('SET_USER_HANDLE', userHandle)
    }
  }
}

export default feature



// WEBPACK FOOTER //
// ./src/store/modules/mindblogging.js